import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React, { useState } from 'react';

import { CustomerItemDto, CustomerPropertiesDto } from '@/api/generated';
import { useCustomTableInitialParamsSetter } from '@/components/table/util/useCustomTableInitialParamsSetter.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { CustomerShortDetails } from '@/views/customers/list/components/CustomerShortDetails.comp.tsx';
import { ProcessAddCustomerDialog } from '@/views/processesDetails/components/dialog/addCustomer/ProcessAddCustomerDialog.comp.tsx';

type Props = {
  customer?: Omit<CustomerPropertiesDto, 'address'> | null;
  onCustomerSelected: (customer: CustomerItemDto | null) => void;
};

const addCustomerKey = 'contactAddCustomer';

export const ContactsCreateSelectClient: React.FC<Props> = props => {
  const { customer, onCustomerSelected } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { t } = useTranslationWithPrefix('views.contactsCreate.selectClient');
  const { customTableInitialParamsSetter } = useCustomTableInitialParamsSetter();

  const handleOpenDialog = () => {
    customTableInitialParamsSetter({ tableSubKey: addCustomerKey, value: '' });
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleSelectCustomer = (customer: CustomerItemDto) => {
    onCustomerSelected(customer);
    handleCloseDialog();
  };

  const handleClearCustomer = () => {
    onCustomerSelected(null);
  };

  if (!customer) {
    return (
      <>
        <Box>
          <Button onClick={handleOpenDialog}>{t('button.selectCustomer')}</Button>
        </Box>

        {isDialogOpen && (
          <ProcessAddCustomerDialog
            onCloseClick={handleCloseDialog}
            onSelectCustomer={handleSelectCustomer}
            tableKey={addCustomerKey}
          />
        )}
      </>
    );
  }

  return (
    <>
      <Stack spacing={2}>
        <CustomerShortDetails customer={customer} title={t('customerSectionTitle')} />
        <Stack direction="row" spacing={2}>
          <Button onClick={handleClearCustomer} variant="outlined">
            {t('button.clearCustomer')}
          </Button>
          <Button onClick={handleOpenDialog}>{t('button.selectCustomer')}</Button>
        </Stack>
      </Stack>
      {isDialogOpen && (
        <ProcessAddCustomerDialog
          onCloseClick={handleCloseDialog}
          onSelectCustomer={handleSelectCustomer}
        />
      )}
    </>
  );
};
